var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.208 19.1943C27.208 18.588 27.1536 18.0051 27.0525 17.4454H19V20.7527H23.6015C23.4032 21.8215 22.8009 22.727 21.8953 23.3333V25.4785H24.6585C26.2753 23.9901 27.208 21.7982 27.208 19.1943Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 27.55C21.3085 27.55 23.2439 26.7844 24.6585 25.4786L21.8953 23.3333C21.1297 23.8463 20.1503 24.1494 19 24.1494C16.7731 24.1494 14.8882 22.6454 14.2159 20.6245H11.3594V22.8397C12.7662 25.634 15.6577 27.55 19 27.55Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2161 20.6245C14.0451 20.1115 13.9479 19.5635 13.9479 19C13.9479 18.4365 14.0451 17.8885 14.2161 17.3755V15.1603H11.3596C10.7805 16.3145 10.4502 17.6203 10.4502 19C10.4502 20.3797 10.7805 21.6855 11.3596 22.8397L14.2161 20.6245Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13.8505C20.2553 13.8505 21.3823 14.2819 22.2684 15.1291L24.7207 12.6768C23.24 11.2972 21.3046 10.45 19 10.45C15.6577 10.45 12.7662 12.3659 11.3594 15.1602L14.2159 17.3755C14.8882 15.3545 16.7731 13.8505 19 13.8505Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f8917598a325fd56cf3dcd7a0d8f371b.svg";
export { ForwardRef as ReactComponent };